<script>
    export let id;
    export let formatModuleID;

    export let height = 100;
    export let width = 100;
    export let y = 0;
    export let x = 0;

    export let shiftY = 0;
    export let shiftX = 0;
</script>

<span
    class="module-calc-modules-part"
    style={`height: ${height}%; width: ${width}%; top: ${parseInt(y) + parseInt(shiftY)}%; left: ${parseInt(x) + parseInt(shiftX)}%;`}
    title={formatModuleID}
>
</span>
